<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <!-- Data Peserta -->
  <CCardBody class="py-0">
    <CRow>
      <div class="col-sm-12 col-xl-12">
        <div class="form-group">
          <label for="" class="font-weight-bold">Pilih Pelatihan</label>
          <multiselect
            class="mulit-select"
            placeholder="Pilih Pelatihan"
            :show-labels="false"
            :custom-label="customLabel ? customLabel : '-'"
            required
            v-model="webinar"
            :options="dataWebinar"
            @select="pilihPelatihan">
              <template slot="option"  slot-scope="{ option }">{{ option.no_laporppl ? option.no_laporppl + ' - ' : '' }} {{ option.nama_pelatihan ? option.nama_pelatihan + ' - ' : '' }} {{ option.tanggal_dimulai ?  option.tanggal_dimulai : ''}}</template>
          </multiselect>
        </div>
      </div>
      <div class="col-sm-12 col-xl-12 pt-2 text-right">
        <button class="btn btn-md btn-info" @click="resetFilter">
          Reset Filter
        </button>
        <button class="btn btn-success btn-md ml-3" @click="changePelatihan">
          Terapkan Filter
        </button>
      </div>
      <div class="col-sm-12 col-xl-2 mt-4 pt-2">
      </div>
    </CRow>
    <br />
    <CRow class="mt-3">
      <div class="col-sm-12 col-xl-6">
        <label for="">Data Per Halaman</label>
        <div class="form-group">
          <CSelect
            class="float-left"
            @change="changePageSize"
            :options="[10, 25, 100, 'Semua Data']"
          />
        </div>
      </div>

      <div class="col-sm-12 col-xl-4 ml-auto">
        <div class="form-group">
          <CInput
            class="float-right"
            label="Pencarian"
            placeholder="Cari Data .."
            v-model="searchPelatihan"
          />
        </div>
      </div>
    </CRow>
  </CCardBody>
  <!-- End Data Peserta -->
</template>

<script>
import DataPesertaService from "@/services/pelatihan/data-peserta.service";
import WorkshopService from "@/services/pelatihan/workshop.service";
import PeriodeService from "@/services/datamaster/periode.service";
import { AlertUtils } from "@/mixins/AlertUtils";
import { Pagination } from "@/mixins/Pagination";
import { KategoriAnggota } from "@/mixins/master/KategoriAnggota";
import { exportUtils } from "@/mixins/exportUtils";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import dataPesertaService from '@/services/pelatihan/data-peserta.service';

const fields = [
  {
    key: "no",
    label: "No",
    sorter: true,
    filter: false,
  },
  {
    key: "no_anggota",
    label: "No Anggota",
    sorter: true,
    filter: false,
  },
  {
    key: "nama_lengkap",
    label: "Nama",
    sorter: true,
    filter: false,
  },
  {
    key: "tanggal_daftar",
    label: "Tanggal Daftar",
    sorter: true,
    filter: false,
  },
  {
    key: "status_pembayaran",
    label: "Status Pembayaran",
    sorter: true,
    filter: false,
  },
  {
    key: "aksi",
    _style: "width: 10% text-align: center",
    sorter: false,
    filter: false,
  },
];

export default {
  mixins: [AlertUtils, Pagination, KategoriAnggota, exportUtils],
  filters: {
    date(value) {
      if (!value) return "";
      let options = { year: "numeric", month: "long", day: "numeric" };
      return Intl.DateTimeFormat("id-ID", options).format(value);
    },
  },
  data() {
    return {
      formData: [
        {
          idWorkshopPelatihan: "",
          id_workshop_pelatihan: "",
        },
      ],
      
      pelatihan: "",
      periode: "",
      kategori_anggota: "",
      items: [],
      detailPeserta: {
        id_keanggotaan: "",
        id_user: "",
        id_pelatihan_peserta: "",
        nama_pelatihan: "",
        id_workshop_pelatihan: "",
        no_anggota: "",
        nama_lengkap: "",
        tanggal_daftar: "",
        status_pembayaran: "",
        id_invoice: "",
        created_at: "",
        pelatihan_created_at: "",
        no_lapor_pelatihan: "",
        skp: "",
      },
      dataPelatihan: [],
      dataWebinar : [],
      details: [],
      idWorkshopPelatihan: '',
      webinar: "",
      pelatihan: "",
      periode: "",
      kategori_anggota: "",
      status: false,
      myModal: false,
      modalDetail: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      content: [],
    };
  },

  mounted() { 
    this.getDataOffline("0", '50000', "default");  
    this.getAllKategoriAnggota();    
  },

  methods: {
    customLabel ({ no_laporppl, nama_pelatihan, tanggal_dimulai }) {
      return `${no_laporppl} - ${nama_pelatihan} - ${tanggal_dimulai ? tanggal_dimulai : ''}`
    },
    filterData() {
      this.$parent.filterData(this.formFilter);
      
    },
    resetFilter() {
      this.periode = "";
      this.sertifikasi = "";
      $("#filterStatusPembayaran").val("");
    },
    changePeriode(e) {
      // comment console console.log(e.value);
    },
    pageChange() {
      this.getData(currenPage);
    },
    updateValues(values) {
    },
    

    getData(currentPage, pageSize, idWorkshopPelatihan, filter) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });

      var vm = this;
      idWorkshopPelatihan = vm.idWorkshopPelatihan;

      DataPesertaService.getDataPeserta(
        currentPage,
        pageSize,
        idWorkshopPelatihan,
        filter
      )
        .then((response) => {
          loader.hide();

          // comment console console.log(response.data.data.content + "INI DI SERTIFIKASI");
          const data = {
            items: response.data.data.content,
            totalPages: response.data.data.totalPages,
            currentPage: response.data.data.pageable.pageNumber + 1,
          }
          this.$parent.dataTable(data)
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },

    getDataOffline(currentPage, pageSize, filter) {
    WorkshopService.getDataOffline(currentPage, pageSize, filter)
      .then(response => {
        this.dataWebinar = response.data.data.content;
      })
      .catch(error => {
        // comment console console.log(error);
      });
    },

    downloadSKP(pelatihan, periode) {
      dataPesertaService.downloadSKP(pelatihan.id_workshop_pelatihan, periode.value)
      .then((response) => {
         this.exportData(response.data, "data-peserta-pelatihan-webinar");
        this.alertDownloadSuccess();
      })
      .catch((error) => {
        // comment console console.log(error);
        this.alertDownloadFailed();
      })
    },

    getPelatihan() {
      var vm = this;
      WorkshopService.getWebinar(0,1000000,'default','default')
        .then((response) => {
          vm.dataPelatihan = response.data.data.content;
          // comment console console.log(response.data.data.content);
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },

    changePelatihan() {
      var value = {
        id_workshop_pelatihan : this.idWorkshopPelatihan
      }
      this.$parent.changePelatihan(value);
    },

    pilihPelatihan(value) {
      this.idWorkshopPelatihan = value.id_workshop_pelatihan
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
